const defaults = () => ({
  messages: [],
  responseProvider: 'vertex',
});

export default {
  namespaced: true,
  persist: ['responseProvider'],
  state: defaults,
  mutations: {
    HYDRATE(state, payload) {
      Object.assign(state, payload);
    },
    SET_RESPONSE_PROVIDER(state, provider) {
      state.responseProvider = provider;
    },
    RESET(state) {
      Object.assign(state, defaults());
    },
  },
};
